///这是日语-语法-每一个语法项目的组件

import { forwardRef, react, useImperativeHandle, useRef, useState, useCallback } from "react";
import { List, Button, Dialog, SwipeAction, Image } from "antd-mobile";

import styles from "./GrammaList.module.css"
import "./Adm.css"

const colors = [{ 'backgroundColor': '#daeaf9' }, { 'backgroundColor': '#f9e7daff' }]
var _firstInit = true
//props.order     当前item的顺序
//props.item  当前的gramma信息
//props.disp  当前的显示模式 fix / gramma / main / def / all


export default forwardRef((props, ref) => {
  var c = Number(props.order) % 2
  // var c = Math.random() < 0.5 ? 0 : 1

  var disp = props.disp

  var dfLeft = true, dfRight = true, dfGramma = true, dfDef = true
  switch (disp) {
    case 'continue':
      dfGramma = false
      dfDef = false
      break;
    case 'gramma':
      dfLeft = false
      dfRight = false
      dfDef = false
      break;
    case 'main':
      dfDef = false
      break;
    case 'definition':
      dfLeft = false
      dfRight = false
      dfGramma = false
      break;
    case 'all':
      break;
    default:
      break;
  }

  const [disLeft, setDisLeft] = useState(dfLeft)
  const [disGramma, setDisGramma] = useState(dfGramma)
  const [disRight, setDisRight] = useState(dfRight)
  const [disDef, setDisDef] = useState(dfDef)
  const [trig, setTrig] = useState(0)
  if (_firstInit) {

    if (disLeft !== dfLeft) setDisLeft(dfLeft)
    if (disRight !== dfLeft) setDisRight(dfRight)
    if (disGramma !== dfGramma) setDisGramma(dfGramma)
    if (disDef !== dfDef) setDisDef(dfDef)

    _firstInit = false
  }
  const refresh = () => {
    setTrig(trig + 1)
  }
  const refreshAfterEdit=()=>{

  }
  useImperativeHandle(ref, () => ({
    refresh,
    refreshAfterEdit,
  }))

  return (<div trig={trig} className={styles.listItemContent} style={colors[c]}>
    <div className={styles.upper} >
      {props.item.left_col ?
        <Button onMouseDown={() => setDisLeft(!disLeft)}
          style={disLeft ? {} : { 'color': 'white' }}
          className={styles.btnUpper}>
          {props.item.left_col}
        </Button> : ''}
      <Button onMouseDown={() => setDisGramma(!disGramma)}
        className={styles.btnUpper}
        style={disGramma ? {} : { 'color': 'white' }}>
        {props.item.gramma}
      </Button>
      {props.item.right_col ?
        <Button onMouseDown={() => setDisRight(!disRight)}
          style={disRight ? {} : { 'color': 'white' }}
          className={styles.btnUpper}>
          {props.item.right_col}
        </Button> : ''}
    </div>
    <div className={styles.lower}>
      <Button onMouseDown={() => setDisDef(!disDef)}
        style={disDef ? {} : { 'color': 'white' }}
        className={styles.btnLower}>{props.item.definition}
      </Button>
    </div>
  </div>)
})